import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo } from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import divisionActions from "../../../_actions/_qmsActions/divisionActions";
import qmsFrameworkChangeActions from "../../../_actions/_qmsActions/qmsFrameworkChangeActions";
import qmsRolePermissionActions from "../../../_actions/_qmsActions/qmsRolePermissionActions";
import qmsTeamMemberRoleActions from "../../../_actions/_qmsActions/qmsTeamMemberRoleActions";
import qmsUserActions from "../../../_actions/_qmsActions/qmsUserActions";
import TitleBar from "../../_common/TitleBar";
import "./qmsAdmin.css";
import QmsAdminCmtMain from "./QmsAdminCmtMain";
import QmsAdminDocumentsMain from "./QmsAdminDocumentsMain";
import QmsAdminTeams from "./QmsAdminTeams";

const tabs = [
  { tabId: "teams", label: "Teams/User Groups" },
  { tabId: "documents", label: "Documents" },
  { tabId: "cmt", label: "CMT" },
];

export default function QmsAdmin(props) {
  const { tabId } = props;

  const dispatch = useDispatch();

  const [selectedTabId, selectTab] = useState("teams");
  const [selectedDivision, selectDivision] = useState(null);

  const proDmsUserId = useSelector((state) => state.authentication.user.userId);
  const divisions = useSelector((state) => state.qms.divisions || null);

  useEffect(() => {
    dispatch(divisionActions.getAll());
    dispatch(qmsTeamMemberRoleActions.getAll());
    dispatch(qmsUserActions.getUserRoles());
    dispatch(qmsRolePermissionActions.get(proDmsUserId));
  }, []);

  const divisionOptions = useMemo(
    () =>
      (divisions || []).map((d) => ({
        label: `${d.name} (${d.abbreviation})`,
        value: d.divisionId,
      })),
    [divisions]
  );

  // Temporary!! In the future, preselect based on user's unit
  useEffect(() => {
    selectDivision(divisionOptions[0]);
  }, [divisionOptions]);

  const renderContent = () => {
    switch (selectedTabId) {
      case "teams":
        return (
          <QmsAdminTeams
            tabId={tabId}
            divisionId={selectedDivision ? selectedDivision.value : 0}
          />
        );
      case "documents":
        return (
          <QmsAdminDocumentsMain
            tabId={tabId}
            divisionId={selectedDivision ? selectedDivision.value : 0}
          />
        );
      case "cmt":
        return (
          <QmsAdminCmtMain
            tabId={tabId}
            divisionId={selectedDivision ? selectedDivision.value : 0}
          />
        );
      default:
        return;
    }
  };

  return (
    <React.Fragment>
      <TitleBar titleText="QMS - Admin" menu={null} handleTitleBarAction={() => {}} />
      <div className="row mx-0">
        <div className="col-12 px-2">
          <div className="card mx-0 mt-0 mb-2 w-100 bg-lightgray">
            <div className="card-body p-2">
              <div className="form-row w-100">
                <label htmlFor="divisionSelector" className="mx-2 my-auto">
                  <b>Division:</b>
                </label>
                <Select
                  name="divisionSelector"
                  id="divisionSelector"
                  className="qms-admin-division-selector mr-2"
                  value={selectedDivision}
                  options={divisionOptions}
                  onChange={selectDivision}
                  styles={{
                    // Fixes the overlapping problem of the component
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                />
                <button
                  name="editDivisions"
                  id="editDivisions"
                  className="btn btn-info"
                  onClick={() => {}}
                >
                  <FontAwesomeIcon icon="cog" className="mr-2" />
                  Manage Divisions...
                </button>
              </div>
            </div>
          </div>
          <QmsAdminTabs selectTab={selectTab} selectedTabId={selectedTabId}>
            {renderContent()}
          </QmsAdminTabs>
        </div>
      </div>
    </React.Fragment>
  );
}

function QmsAdminTabs(props) {
  const { selectTab, selectedTabId } = props;

  const renderTab = (tab) => {
    return (
      <li key={tab.tabId} className="nav-item">
        <div
          className={`nav-link border border-secondary border-bottom-0 pointer-cursor ${
            tab.tabId === selectedTabId ? "active admin-tab--border" : ""
          }`}
          id={tab.tabId + "_tab"}
          data-toggle="tab"
          role="tab"
          onClick={() => selectTab(tab.tabId)}
        >
          {tab.label}
        </div>
      </li>
    );
  };

  return (
    <>
      <ul className="nav nav-tabs border-0" role="tablist">
        {tabs.map((tab) => renderTab(tab))}
      </ul>
      <div className="tab-content pa-tab-content">
        <div
          className="tab-pane fade show active border border-secondary pa-tab-pane p-3"
          role="tabpanel"
        >
          {props.children}
        </div>
      </div>
    </>
  );
}
